import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import getCategories from '../../api/GetCategories';
import createCategory from '../../api/CreateCategory';
import updateCategory from '../../api/UpdateCategory';
import deleteCategory from '../../api/DeleteCategory';

const DEFAULT_COVER = '/images/default-book-cover.png';

const initialState = {
    items: [
        /*{
            id: "BK001",
            title: "Le Petit Prince",
            author: "Antoine de Saint-Exupéry",
            category: "Littérature",
            rating: 4.9,
            status: "Disponible",
            cover: "https://labtice.ch/data/biblius/images/Le-Petit-Prince.jpg",
            publisher: "FOLIO JUNIOR",
            year: "1943",
            summary: "Le Petit Prince raconte l'histoire d'un petit garçon qui voyage sur différentes planètes pour découvrir l'amitié et l'amour.",
        },
        {
            id: "BK002",
            title: "1984",
            author: "George Orwell",
            category: "Drame",
            rating: 4.8,
            status: "Emprunté",
            cover: "https://labtice.ch/data/biblius/images/image2r.jpg",
            publisher: "Gallimard",
            year: "1949",
            summary: "Le livre raconte l'histoire de Winston Smith, un agent de surveillance qui vit dans un monde où la tyrannie gouverne.",
            borrower: {
                id: 2,
                name: "James Wilson",
                role: "Enseignant",
                email: "j.wilson@university.edu",
                phone: "+1 234 567 891",
                status: "Actif",
                avatar: "/avatars/teacher.png"
            }
        },
        {
            id: "BK003",
            title: "Project Hail Mary",
            author: "Andy Weir",
            category: "Sci-Fi",
            rating: 4.9,
            status: "Disponible",
            cover: "https://images.unsplash.com/photo-1476275466078-4007374efbbe?w=400&h=600&fit=crop",
            publisher: "Ballantine Books",
            year: "2021",
            summary: "Ryland Grace est le seul survivant d'une mission désespérée de la dernière chance - et s'il échoue, l'humanité et la terre elle-même périront."
        },
        {
            id: "BK004",
            title: "Thinking, Fast and Slow",
            author: "Daniel Kahneman",
            category: "Psychologie",
            rating: 4.6,
            status: "Disponible",
            cover: "https://images.unsplash.com/photo-1555252586-d711dbbef984?w=400&h=600&fit=crop",
            publisher: "Farrar, Straus and Giroux",
            year: "2011",
            summary: "Le célèbre psychologue Daniel Kahneman nous emmène dans une visite révolutionnaire de l'esprit et explique les deux systèmes qui dirigent notre façon de penser."
        },
        {
            id: "BK005",
            title: "The Midnight Library",
            author: "Matt Haig",
            category: "Fiction",
            rating: 4.5,
            status: "Emprunté",
            cover: "https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=400&h=600&fit=crop",
            publisher: "Viking",
            year: "2020",
            summary: "Entre la vie et la mort, il y a une bibliothèque, et dans cette bibliothèque, les étagères s'étendent à l'infini. Chaque livre offre une chance d'essayer une autre vie que vous auriez pu vivre.",
            borrower: {
                id: 1,
                name: "Sarah Chen",
                role: "Étudiant",
                email: "sarah.c@university.edu",
                phone: "+1 234 567 890",
                status: "Actif",
                avatar: "/avatars/student.png"
            }
        },
        {
            id: "BK006",
            title: "Zero to One",
            author: "Peter Thiel",
            category: "Business",
            rating: 4.7,
            status: "Disponible",
            cover: "https://images.unsplash.com/photo-1513475382585-d06e58bcb0e0?w=400&h=600&fit=crop",
            publisher: "Crown Business",
            year: "2014",
            summary: "Si vous voulez construire un avenir meilleur, vous devez croire aux secrets. Le grand secret de notre époque est qu'il reste encore des frontières inexplorées et de nouvelles inventions à créer."
        },
        {
            id: "BK007",
            title: "Sapiens",
            author: "Yuval Noah Harari",
            category: "Histoire",
            rating: 4.8,
            status: "Disponible",
            cover: "https://images.unsplash.com/photo-1531988042231-d39a9cc12a96?w=400&h=600&fit=crop",
            publisher: "Harper",
            year: "2015",
            summary: "Il y a cent mille ans, au moins six espèces d'humains habitaient la terre. Aujourd'hui, il n'en reste qu'une. Nous. Homo sapiens."
        },
        {
            id: "BK008",
            title: "Deep Work",
            author: "Cal Newport",
            category: "Productivité",
            rating: 4.6,
            status: "Emprunté",
            cover: "https://images.unsplash.com/photo-1506880018603-83d5b814b5a6?w=400&h=600&fit=crop",
            publisher: "Grand Central Publishing",
            year: "2016",
            summary: "Le travail en profondeur est la capacité de se concentrer sans distraction sur une tâche cognitivement exigeante. C'est une compétence qui vous permet de maîtriser rapidement des informations compliquées.",
            borrower: {
                id: 3,
                name: "Elena Rodriguez",
                role: "Bibliothécaire",
                email: "elena.r@university.edu",
                phone: "+1 234 567 892",
                status: "Actif",
                avatar: "/avatars/librarian.png"
            }
        },*/
    ],
    categoryBooks: [], // Initialized empty, populated by API
    searchQuery: "",
    isScanModalOpen: false,
    currentBook: null,
    status: 'idle', // 'idle' | 'loading' | 'succeeded' | 'failed'
    error: null
};

export const fetchCategories = createAsyncThunk('books/fetchCategories', async ({ API_BASE, token, code_etablissement }) => {
    const response = await getCategories(API_BASE, token, code_etablissement);
    return response;
});

export const addCategoryThunk = createAsyncThunk('books/addCategory', async ({ API_BASE, token, name, code_etablissement }) => {
    const response = await createCategory(API_BASE, token, { name, code_etablissement });
    return response;
});

export const updateCategoryThunk = createAsyncThunk('books/updateCategory', async ({ API_BASE, token, id, name }) => {
    const response = await updateCategory(API_BASE, token, id, { name });
    return response;
});

export const deleteCategoryThunk = createAsyncThunk('books/deleteCategory', async ({ API_BASE, token, id }) => {
    await deleteCategory(API_BASE, token, id);
    return id;
});


const booksSlice = createSlice({
    name: 'books',
    initialState,
    reducers: {
        setSearchQuery: (state, action) => {
            state.searchQuery = action.payload;
        },
        setScanModalOpen: (state, action) => {
            state.isScanModalOpen = action.payload;
        },
        setCurrentBook: (state, action) => {
            state.currentBook = action.payload;
        },
        setBooks: (state, action) => {
            state.items = action.payload;
        },
        addBook: (state, action) => {
            state.items.unshift({ ...action.payload, id: `BK00${state.items.length + 1}` });
        },
        updateBook: (state, action) => {
            const { id, ...changes } = action.payload;
            const index = state.items.findIndex(b => (b.ID || b.id) == id);
            if (index !== -1) {
                state.items[index] = { ...state.items[index], ...changes };
            }
            if (state.currentBook && (state.currentBook.ID || state.currentBook.id) == id) {
                state.currentBook = { ...state.currentBook, ...changes };
            }
        },
        deleteBook: (state, action) => {
            state.items = state.items.filter(b => (b.ID || b.id) !== action.payload);
        },
        reserveBook: (state, action) => {
            const { bookId } = action.payload;
            const book = state.items.find(b => (b.ID || b.id) == bookId);
            if (book) {
                book.status = 'Réservé';
            }
            if (state.currentBook && (state.currentBook.ID || state.currentBook.id) == bookId) {
                state.currentBook.status = 'Réservé';
            }
        },
        unreserveBook: (state, action) => {
            const { bookId } = action.payload;
            const book = state.items.find(b => (b.ID || b.id) == bookId);
            if (book) {
                book.status = 'Disponible';
            }
            if (state.currentBook && (state.currentBook.ID || state.currentBook.id) == bookId) {
                state.currentBook.status = 'Disponible';
            }
        },
        updateBookCover: (state, action) => {
            const { id, cover } = action.payload;
            const book = state.items.find(b => (b.ID || b.id) == id);
            if (book) {
                book.cover = cover;
            }
            if (state.currentBook && (state.currentBook.ID || state.currentBook.id) == id) {
                state.currentBook.cover = cover;
            }
        },
        loanBook: (state, action) => {
            const { bookId, borrower } = action.payload;
            const book = state.items.find(b => (b.ID || b.id) == bookId);
            if (book) {
                book.status = 'Emprunté';
                book.borrower = borrower;
            }
            if (state.currentBook && (state.currentBook.ID || state.currentBook.id) == bookId) {
                state.currentBook.status = 'Emprunté';
                state.currentBook.borrower = borrower;
            }
        },
        returnBook: (state, action) => {
            const { bookId } = action.payload;
            const book = state.items.find(b => (b.ID || b.id) == bookId);
            if (book) {
                book.status = 'Disponible';
                book.borrower = null;
            }
            if (state.currentBook && (state.currentBook.ID || state.currentBook.id) == bookId) {
                state.currentBook.status = 'Disponible';
                state.currentBook.borrower = null;
            }
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchCategories.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchCategories.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.categoryBooks = action.payload;
            })
            .addCase(fetchCategories.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.error.message;
            })
            // category crud
            .addCase(addCategoryThunk.fulfilled, (state, action) => {
                state.categoryBooks.push(action.payload);
                state.categoryBooks.sort((a, b) => a.name.localeCompare(b.name));
            })
            .addCase(updateCategoryThunk.fulfilled, (state, action) => {
                const index = state.categoryBooks.findIndex(c => c.ID === action.payload.ID);
                if (index !== -1) {
                    state.categoryBooks[index] = action.payload;
                }
            })
            .addCase(deleteCategoryThunk.fulfilled, (state, action) => {
                state.categoryBooks = state.categoryBooks.filter(c => c.ID !== action.payload);
            });
    }
});


export const { setSearchQuery, setScanModalOpen, setCurrentBook, setBooks, addBook, updateBook, deleteBook, updateBookCover, loanBook, returnBook, reserveBook, unreserveBook } = booksSlice.actions;
export default booksSlice.reducer;
